module.exports = __webpack_public_path__ + "static/media/ic_tinco_playstore.6c33d165.png";